document.addEventListener("DOMContentLoaded",function(){
 // Handle open model event
 $('.eula-trigger').on('click', function (e) {
    e.preventDefault();
    let download = e.target.getAttribute('data-href');
    $('#firmware-download-link').attr('href', download);
    if (e.target.getAttribute('data-type') === 'opticalDrive') {
      window.open(download);
    } else {
      $('body').addClass('NewsletterActive').addClass('scrollHidden');
      $('.eula-popup').addClass('active').trigger('focus');
      focusElement = window;
      window.focus();
      focusElement = '';
    }
  });

  // Handle close modal event
  $('.pop_cross').on('click', function (e) {
    e.preventDefault();
    $('.eula-popup').removeClass('active');
    $('body').removeClass('NewsletterActive').removeClass('scrollHidden');

    window.focus();
    focusElement = '';
  });
})